import { render, staticRenderFns } from "./eventReceptComponent.vue?vue&type=template&id=1dd48a51&"
import script from "./eventReceptComponent.vue?vue&type=script&lang=ts&"
export * from "./eventReceptComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports